'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Accordion = require('../Accordion-c861026d.js');
require('../tslib.es6-130a177d.js');
require('react');
require('../Icons/PlusIcon/index.js');
require('styled-components');
require('../Icons/MinusIcon/index.js');
require('../typography/index.js');



exports.default = Accordion.AccordionMenu;
//# sourceMappingURL=index.js.map
